<template>
  <div class="app-layout-auth">
    <AppHeader />
    <main class="app-layout-auth__main">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.app-layout-auth {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-base);
}

.app-layout-auth__main {
  flex: 1;
  padding-top: var(--header-height);
}
</style>
